export default {
   SET_ALL_BRANCHES: (state, branches) => {
      state.branches.allBranches = branches;
   }
}
